import { J as JS_PREFIX } from './built-constants-439d5572.js';
import './built-loglevel-42c63e3e.js';
import { s as showElement, h as hideElement } from './built-element-utils-09877efc.js';
import './built-js.cookie-7baadf9c.js';
import { a as sessionStorageAvailable, g as getObjectFromSessionStorage, s as setObjectInSessionStorage } from './built-storage-042e9783.js';

// @ts-check
/* Sensible defaults */

const OPEN_DELAY_SECONDS_DEFAULT = 1;
const CLOSE_DELAY_SECONDS_DEFAULT = 3;
/**
 * Initializes a scoped tooltip
 * @param {HTMLElement} tooltipEl
 */

const initTooltip = tooltipEl => {
  // We'll need the timer ID to stop the close timer when appropriate
  let closeTimerId; // Get the settings from the data attributes

  const settings = tooltipEl.dataset;
  /** @type {number} */

  const openDelayMilliseconds = (Number(settings.tooltipOpenDelaySeconds) || OPEN_DELAY_SECONDS_DEFAULT) * 1000;
  /** @type {number} */

  const closeDelayMilliseconds = (Number(settings.tooltipCloseDelaySeconds) || CLOSE_DELAY_SECONDS_DEFAULT) * 1000;
  /**
   * Instructions for when the tooltip opens
   */

  const openTooltip = () => {
    // Store the timer ID so we can clear it, when appropriate
    closeTimerId = setTimeout(closeTooltip, closeDelayMilliseconds);
    showElement(tooltipEl);
    /**
     * @todo Refactor per the comment in PR
     * @see https://github.com/decathlon-usa/shopify-theme-decathlonusa/pull/1045#discussion_r346571932
     */

    addEventListeners();
  };
  /**
   * Instructions for when the tooltip closes
   */


  const closeTooltip = () => {
    clearTimeout(closeTimerId);
    hideElement(tooltipEl);
    removeEventListeners();
  };
  /**
   * Click handler
   *
   * If a click happens outside of the tooltip, close the tooltip.
   * @param {Event} event
   */


  const onClick = event => {
    const isClickInsideTooltip = tooltipEl.contains(
    /** @type {Node} */
    event.target);
    if (!isClickInsideTooltip) closeTooltip();
  };
  /**
   * Keyboard event handler
   *
   * If the `Escape` key is pressed, close the tooltip.
   * @param {KeyboardEvent} event
   */


  const onKeydown = event => {
    if (event.key === 'Escape') closeTooltip();
  };
  /**
   * Hover on handler
   */


  const onTooltipMouseEnter = () => {
    clearTimeout(closeTimerId);
  };
  /**
   * Hover off handler
   */


  const onTooltipMouseLeave = () => {
    // Store the close timer ID to clear it later
    closeTimerId = setTimeout(closeTooltip, closeDelayMilliseconds);
  };
  /**
   * Handles adding all event listeners
   */


  const addEventListeners = () => {
    tooltipEl.addEventListener('mouseenter', onTooltipMouseEnter);
    tooltipEl.addEventListener('mouseleave', onTooltipMouseLeave);
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('click', onClick);
  };
  /**
   * Handles removing all event listeners for cleanup
   */


  const removeEventListeners = () => {
    tooltipEl.removeEventListener('mouseenter', onTooltipMouseEnter);
    tooltipEl.removeEventListener('mouseleave', onTooltipMouseLeave);
    document.removeEventListener('keydown', onKeydown);
    document.removeEventListener('click', onClick);
  }; // Initialize tooltip


  setTimeout(openTooltip, openDelayMilliseconds);
};

// @ts-check

const runSetup = () => document.querySelectorAll("." + JS_PREFIX + "Tooltip").forEach(
/** @param {HTMLElement} tooltipEl */
tooltipEl => {
  /**
   * `offsetParent` returns `null` if the element or its parent element has the
   * `display` property set to `none`. We don't want to initialize tooltip at smaller
   * viewports. At smaller viewports, the tooltip parent `display` property is set to `none`.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
   *
   * This feels a bit hacky but I couldn't come up with a better solution.
   * I didn't want to hard code a viewport size for when to or not initialize the tooltip.
   * @todo Is there a better solution to not running the Tooltip JS at smaller viewports?
   */
  if (tooltipEl.parentElement.offsetParent === null) return;
  initTooltip(tooltipEl);
}); // Limit the Sign-In overlay (tooltip) to only show once per browser session


if (sessionStorageAvailable) {
  const signInOverlayHasShown = 'sign-in-overlay-has-shown';

  if (getObjectFromSessionStorage(signInOverlayHasShown) !== true) {
    setObjectInSessionStorage(signInOverlayHasShown, true);
    runSetup();
  }
} else {
  // If no session storage, then always show tooltip
  runSetup();
}
